import {BASE_URL} from "../services/api";

const TOKEN_KEY = 'jwt_portal-seguranca';

export const setCookie = (name, value, days = 7) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
}

export const getCookie = (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) {
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
    }
    return null;
}

export const removeCookie = (name) => {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
}

export const clearAllAuthCookies = () => {
    removeCookie(TOKEN_KEY);
    removeCookie('usuario');
    removeCookie('filial');
    removeCookie('regional');
    removeCookie('todasRegionais');
}

export const login = () => {
    const dadosUsuarioStr = getCookie("usuario") || localStorage.getItem("usuario");
    if (dadosUsuarioStr) {
        const dadosUsuario = JSON.parse(dadosUsuarioStr);
        setCookie(TOKEN_KEY, dadosUsuario.accessToken);
        localStorage.setItem(TOKEN_KEY, dadosUsuario.accessToken);
    }
}

export const logout = () => {
    clearAllAuthCookies();
    localStorage.clear();
    window.location.href = `${BASE_URL}painel-modulos`;
}

export const isLogin = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlToken = urlParams.get('accessToken');

    if (urlToken) {
        setCookie(TOKEN_KEY, urlToken);
        localStorage.setItem(TOKEN_KEY, urlToken);
        return true;
    }

    if (getCookie(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY)) {
        return true;
    }
    return false;
}

export const getAccessToken = () => {
    const token = getCookie(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);
    if (token) {
        return token;
    } else {
        return {};
    }
}

export const getAuthorizationHeader = () => {
    const token = getCookie(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);
    if (token) {
        return { 'Authorization': token };
    } else {
        return {};
    }
}

export const mapearUrlModulo = (urlOriginal) => {
    if (!urlOriginal) return urlOriginal;

    return urlOriginal.replace('originar-dev.amaggi.com.br', 'originar-tst.amaggi.com.br');
}

export const clearUrlToken = () => {
    const url = new URL(window.location);
    if (url.searchParams.has('accessToken')) {
        url.searchParams.delete('accessToken');
        window.history.replaceState({}, document.title, url.pathname + url.search);
    }
}